import { GIFT_CERTIFICATE } from '~/features/commerce-api/utils';
import { CustomBasketOrderData } from '~/lib/data-contract/salesforce';
import { PaymentMethod } from '~/shared/constants';

export const usePaymentDetails = (
    basket: CustomBasketOrderData | undefined,
    membership: boolean,
) => {
    if (!basket) {
        return {
            basePrice: 0,
            remainingTotal: 0,
            discountPrice: 0,
            giftcardUsage: 0,
            bonusRewardTotals: { amount: 0, quantity: 0 },
        };
    }

    const originalGiftcardDiscount =
        basket.paymentInstruments
            ?.filter((x) => x.paymentMethodId === GIFT_CERTIFICATE)
            .map((x) => x.amount ?? 0)
            .reduce((prev, current) => prev + current, 0) ?? 0;

    const bonusRewardTotals = basket.paymentInstruments
        ?.filter((x) => x.paymentMethodId === PaymentMethod.LOYALTY)
        .reduce(
            (acc: { amount: number; quantity: number }, x) => ({
                amount: acc.amount + (x.amount ?? 0),
                quantity: acc.quantity + 1,
            }),
            { amount: 0, quantity: 0 },
        ) ?? { amount: 0, quantity: 0 };

    const basePrice = basket.c_subTotalRetailPrices ?? 0;
    const orderTotal = basket.orderTotal ?? 0;

    let discountPrice = basket.c_totalDiscountExclShipping ?? 0;
    let remainingTotal = (basket?.c_remainingTotal ?? 0) < 0 ? 0 : basket?.c_remainingTotal ?? 0;
    let giftcardUsage =
        originalGiftcardDiscount > orderTotal ? orderTotal : originalGiftcardDiscount;

    if (membership) {
        const memberDiscount = basket.c_totalMemberDiscount ?? 0;
        discountPrice = discountPrice + memberDiscount;
        const memberOrderTotal = orderTotal - memberDiscount;

        giftcardUsage =
            originalGiftcardDiscount > memberOrderTotal
                ? memberOrderTotal
                : originalGiftcardDiscount;

        remainingTotal =
            giftcardUsage && giftcardUsage < originalGiftcardDiscount
                ? 0
                : remainingTotal - memberDiscount;
    }
    return { basePrice, remainingTotal, discountPrice, giftcardUsage, bonusRewardTotals };
};
